import type { ChatGroup } from "../types"

/**
 * Whether `ownHandle` manages the group: its owner or a listed admin. An
 * ownerless group (owner null) is managed by no one (ENGMAN-397). False until
 * both the group record and the session resolve, so neither undefined reads as
 * management.
 */
export function groupManagedBy(
  group: ChatGroup | undefined,
  ownHandle: string | undefined
): boolean {
  if (!group || ownHandle === undefined) return false

  return group.owner === ownHandle || group.admins.includes(ownHandle)
}
